import styled from 'styled-components';

import { BodyS } from 'atoms/typography';

const Text = styled(BodyS)`
  display: inline-block;
  background-color: var(--c-brand-600);
  border-radius: var(--unit);
  padding: 0 var(--unit);
`;

type Props = { amount: number };
export const InventoryCounter = ({ amount }: Props) => (
  <Text bold color="var(--c-white)">
    x{amount}
  </Text>
);
